<template>
  <div>
    <div class="node__wrapper">
      <Message v-if="typing" class="node-typing" :isUser="isUser">
        <Typing />
      </Message>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import Message from './Message';
import Typing from './Typing';

export default {
  components: {
    Message,
    Typing,
  },

  props: {
    delayed: {
      type: Boolean,
      default: false,
    },
    isUser: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const typing = computed(() => props.delayed);

    return {
      typing,
    };
  },
};
</script>

<style lang="scss">
@keyframes wave {
  0%,
  60%,
  100% {
    transform: initial;
  }
  25% {
    transform: translateY($bb-spacing-2 * -1);
  }
  45% {
    transform: translateY($bb-spacing-1);
  }
}
</style>

<style lang="scss" scoped>
.node {
  margin: $bb-spacing-2 $bb-spacing-4;

  &.is-group {
    margin: $bb-spacing-4 0;
  }

  &:not(.is-inner-node):first-child {
    margin-top: $bb-spacing-4;
  }

  &:not(.is-inner-node):last-child {
    margin-bottom: $bb-spacing-6;
  }
}

.node-typing {
  :deep(.node-message__content) {
    display: flex;
    height: $bb-spacing-10;
    width: $bb-spacing-24;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
}
</style>
